module.exports = __webpack_public_path__ + "static/media/logo-위즈돔@3x.47d31e1e.png";